"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var uniq = require('lodash/uniq');

var flattenDeep = require('lodash/flattenDeep');

var getDesign = function getDesign(product) {
  return product.design_name;
};

function PrintJobDesignNames(_ref) {
  var printJob = _ref.printJob,
      variant = _ref.variant;
  var filterer = getDesign;

  if (variant === 'letterpress') {
    filterer = function filterer(product) {
      return product.type.match(/letterpress/i) && product.design_name;
    };
  }

  var design_styles = uniq(flattenDeep(printJob.products.filter(filterer).map(getDesign)));
  return /*#__PURE__*/React.createElement("span", null, "Design Style: ", design_styles.join(', ').toUpperCase());
}

PrintJobDesignNames.propTypes = {
  variant: PropTypes.oneOf(['digital', 'letterpress']),
  printJob: PropTypes.shape({
    products: PropTypes.array.isRequired
  }).isRequired
};
module.exports = PrintJobDesignNames;